export default __webpack_public_path__ + "static/media/drinks.ef1e74d4.jpg";